export default "__VITE_ASSET__CamkVxB0__"